import { TrainingCategory, AppliedTraining, TrainingContent, TrainingQuiz, TrainingProgress } from "../../model/TrainingModel";

export interface TrainingState {
    loading: boolean;
    error: boolean;
    categories: Array<TrainingCategory>;
    loadingClient: boolean;
    errorClient: boolean;
    categoriesClient: Array<TrainingCategory>;
    loadingApplied: boolean;
    errorApplied: boolean;
    appliedTrainings: Array<AppliedTraining>;
    loadingTrainingContent: boolean;
    errorTrainingContent: boolean;
    trainingContent: Array<TrainingContent>;
    loadingQuiz: boolean;
    errorQuiz: boolean;
    quiz: Array<TrainingQuiz>;
    loadingSaveQuiz: boolean;
    errorSaveQuiz: boolean;
    loadingSaveProgress: boolean;
    errorSaveProgress: boolean;
    loadingGetProgress: boolean;
    errorGetProgress: boolean;
    progress: Array<TrainingProgress>;
    loadingStatus: boolean;
    errorStatus: boolean;
}

export const initialState: TrainingState = {
    loading: false,
    error: false,
    categories: [],
    loadingClient: false,
    errorClient: false,
    categoriesClient: [],
    loadingApplied: false,
    errorApplied: false,
    appliedTrainings: [],
    loadingTrainingContent: false,
    errorTrainingContent: false,
    trainingContent: [],
    loadingQuiz: false,
    errorQuiz: false,
    quiz: null,
    loadingSaveQuiz: false,
    errorSaveQuiz: false,
    loadingSaveProgress: false,
    errorSaveProgress: false,
    loadingGetProgress: false,
    errorGetProgress: false,
    progress: null,
    loadingStatus: false,
    errorStatus: false
}


// WEBPACK FOOTER //
// ./src/store/state/TrainingState.ts